import { useAtom, useAtomValue } from 'jotai';
import { Brain, Check, Crown, MusicNotes } from '@phosphor-icons/react';
import { PASS_PLANS } from '../shared/data/constants';
import { drumActivePlanAtom, drumLanguageAtom, type ActivePlan } from '../shared/store/drumAppAtoms';
import './Subscription.scss';

const ICONS = { MusicNotes, Brain, Crown };

function Subscription() {
  const [activePlan, setActivePlan] = useAtom(drumActivePlanAtom);
  const language = useAtomValue(drumLanguageAtom);
  const currentPlan = PASS_PLANS.find((plan) => plan.id === activePlan);
  const currentGrade = currentPlan ? (language === 'ko' ? currentPlan.gradeKo : currentPlan.gradeEn) : (language === 'ko' ? '일반' : 'FREE');
  const currentRights = currentPlan ? (language === 'ko' ? currentPlan.titleKo : currentPlan.titleEn) : (language === 'ko' ? '무료 공개 콘텐츠 이용' : 'FREE CONTENT ACCESS');

  return (
    <div className="page subscription-page drumhi-pass-page">
      <div className="pass-page-heading">
        <span className="eyebrow">DRUM Hi PASS</span>
        <h1>{language === 'ko' ? '이용할 콘텐츠를 선택하세요.' : 'Choose your full-access plan.'}</h1>
        <p>{language === 'ko' ? '드럼 전체, 인지 전체 또는 두 콘텐츠 전체 이용권을 선택할 수 있습니다.' : 'Choose full Drum, full Mind, or complete access to both.'}</p>
      </div>
      <section className="current-grade" aria-label={language === 'ko' ? '현재 등급' : 'Current grade'}>
        <span>{language === 'ko' ? '내 등급' : 'MY GRADE'}</span><strong>{currentGrade}</strong><small>{currentRights}</small>
      </section>
      <div className="plan-grid drumhi-pass-grid">
        {PASS_PLANS.map((plan) => {
          const isCurrent = activePlan === plan.id;
          const PlanIcon = ICONS[plan.iconName];
          const rights = language === 'ko' ? plan.rightsKo : plan.rightsEn;
          return (
            <article key={plan.id} className={`${plan.id === 'plus' ? 'featured' : ''} ${isCurrent ? 'current' : ''}`}>
              <span className="plan-store">GOOGLE PLAY</span><PlanIcon weight="fill" />
              <span className="plan-grade">{language === 'ko' ? `${plan.gradeKo} 등급` : `${plan.gradeEn} GRADE`}</span>
              <h2>{language === 'ko' ? plan.titleKo : plan.titleEn}</h2>
              <div className="plan-price"><strong>{language === 'ko' ? plan.priceKo : plan.priceEn}</strong><span>/ month</span></div>
              <ul>{rights.map((right) => <li key={right}><Check weight="bold" />{right}</li>)}</ul>
              <button type="button" disabled={isCurrent} onClick={() => setActivePlan(plan.id as ActivePlan)}>{isCurrent ? (language === 'ko' ? '현재 이용 중' : 'CURRENT PLAN') : (language === 'ko' ? `${plan.gradeKo} 선택` : `CHOOSE ${plan.gradeEn}`)}</button>
            </article>
          );
        })}
      </div>
      <small className="billing-note">{language === 'ko' ? 'Google Play에서 매월 자동 갱신되며 언제든 해지할 수 있습니다.' : 'Renews automatically through Google Play. Cancel anytime.'}</small>
    </div>
  );
}

export default Subscription;
